import React from 'react';
import { CheckIcon, FlameIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach Geothermal Energy with confidence starting today'];
export function FinalCta() {
  return <section className="border-t border-white/5 bg-carbon py-16 sm:py-20" aria-labelledby="final-title" data-id="element-88" data-mp="1jbk9e684mx9p">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-89" data-mp="1eds48aih1enk">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-lava" data-id="element-90" data-mp="1t37s9iqmb5zk">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="1o4wkrensp7ki" /> {productShortName}
        </p>
        <p className="mt-3" data-id="element-92" data-mp="222uyqiy7f1zh">
          <span className="inline-flex rounded-full border border-energy/50 bg-petrol px-3 py-1 text-[11px] font-extrabold uppercase tracking-[.16em] text-energy" data-id="element-93" data-mp="22462iirng9ql">
            International Edition
          </span>
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance font-display text-4xl font-bold leading-[1.05] text-snow sm:text-5xl" data-id="element-94" data-mp="n7yyr9am3wt6">
          Created by geothermal energy education specialists, for educators worldwide.
        </h2>

        <Countdown className="mt-8" data-id="element-95" data-mp="1246g81umyk4r" />

        <div className="mt-8 flex flex-col gap-5 rounded-2xl border-2 border-energy bg-petrol p-6 text-left shadow-2xl shadow-black/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-96" data-mp="164qbt0zk9fos">
          <p data-id="element-97" data-mp="1b173u69vse75">
            <b className="block text-sm uppercase leading-tight text-snow" data-id="element-98" data-mp="1fujpc7j9k4vo">{productShortName}</b>
            <span className="text-sm text-muted" data-id="element-99" data-mp="1kt3cucdi9oq5">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-100" data-mp="1puahw3o9k9t4">
            <p className="text-sm text-muted" data-id="element-101" data-mp="1ttj9p2zqtxm1">
              <span className="mr-2 line-through decoration-lava decoration-2" data-id="element-102" data-mp="1tuawppf9yn0p">{priceBefore}</span>
              <b className="font-display text-2xl text-energy" data-id="element-103" data-mp="3qux8wj3i3syh">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" arrow className="mt-2 w-full sm:w-auto sm:px-8 sm:py-4 sm:text-base" data-id="element-104" data-mp="3lx5jpwu8qkxz">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-105" data-mp="8gy26jwq6zse">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-106" data-mp="mfxhv229g4cf">
              <CheckIcon className="h-4 w-4 text-lava" aria-hidden="true" data-id="element-107" data-mp="ielw57mic39i" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}